export default "__VITE_ASSET__BVBXa$J5__"